import { lazy, Suspense, useContext, useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import UsersPage from "./pages/UsersPage";
import DashboardPage from "./pages/DashboardPage";
import LegacyDashboardPage from "./pages/LegacyDashboardPage";
import EnvironmentalFeedPage from "./pages/EnvironmentalFeedPage";
import DevicesPage from "./pages/DevicesPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import SharedEnvironmentalFeedPage from "./pages/SharedEnvironmentalFeedPage";
import HistoricalDataPage from "./pages/HistoricalDataPage";
import UsersCreatePage from "./pages/UsersCreatePage";
import UsersEditPage from "./pages/UsersEditPage";
import Layout from "./components/Layout/Layout";
import AuthContext from "./store/auth-context";
import { TitleContext, ValueContextType } from "./components/Context";
import { NotificationProvider } from "./NotificationContext";
import { HistoricalDataProvider } from "./HistoricalDataContext";
import { ProtectedRoute } from "./ProtectedRoute";
import axios from "axios";
import { MessageFeedProvider } from "./MessageFeedContext";
import { trackPageView } from "./services/analytics";
function AnalyticsNavigationTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
}
const GuardianesPage = lazy(() => import("./pages/GuardianesPage"));

function GuardianesLoading() {
  return <main style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>Cargando Guardianes…</main>;
}

function App() {
  const authCtx = useContext(AuthContext);
  const [title, setTitle] = useState<ValueContextType | any>("");


  // Axios interceptor for adding Authorization headers
  axios.interceptors.request.use(
    (config) => {
      const token = authCtx.token;
      if (token && config.headers !== undefined) {
        config.headers["Authorization"] = "Bearer " + token;
        config.headers["Content-Type"] = "application/json";
      }
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  const element = (
    <ProtectedRoute>
      <NotificationProvider>
        <Layout />
      </NotificationProvider>
    </ProtectedRoute>
  );

  return (
    <TitleContext.Provider value={{ title, setTitle }}>
      <AnalyticsNavigationTracker />
      <NotificationProvider>
        <HistoricalDataProvider>
          <MessageFeedProvider> {/* Agregamos el proveedor del feed aquí */}
            <Routes>
              <Route
                path="/guardianes-de-protea"
                element={(
                  <Suspense fallback={<GuardianesLoading />}>
                    <GuardianesPage />
                  </Suspense>
                )}
              />
              <Route element={element}>
                <Route path="/users" element={<UsersPage />} />
                <Route path="/users-create" element={<UsersCreatePage />} />
                <Route path="/users-edit/:user_id" element={<UsersEditPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/dashboard-legacy" element={<LegacyDashboardPage />} />
                <Route path="/environmental-feed" element={<EnvironmentalFeedPage />} />
                <Route path="/devices" element={<DevicesPage />} /> {/* Ahora envuelto por el contexto del feed */}
                <Route path="/history" element={<HistoricalDataPage />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
              </Route>
              <Route path="/share/environmental-feed/:candidateId" element={<SharedEnvironmentalFeedPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="*" element={<LoginPage />} />
            </Routes>
          </MessageFeedProvider>
        </HistoricalDataProvider>
      </NotificationProvider>
    </TitleContext.Provider>
  );
}

export default App;
